import React, {Component} from 'react';
import {connect} from 'react-redux';
import appConfig from '../../../../../../appConfig/AppConfig';
import {urlBuilder} from '../../../../../../appModules/utilities/googleMapsUrlHelper';

export class Map extends Component {
  static propTypes = {
    funeralHome: React.PropTypes.object.isRequired,
    apiKey: React.PropTypes.string.isRequired,
  };

  state = {
    imageUrl: urlBuilder(this.props.apiKey, this.props.funeralHome),
  };

  handleOnError = () => {
    this.setState({imageUrl: null});
  };

  render() {
    if (this.state.imageUrl) {
      return (
        <a
          href={this.props.href}
          target="_blank"
          className="google-static-map"
          style={{backgroundImage: `url('${this.state.imageUrl}')`}}
          onError={this.handleOnError}
        />
      );
    }
    return null;
  }
}

const mapStateToProps = state => ({
  funeralHome: state.funeralHomeStore,
  apiKey: `${appConfig().googleApi.apiKey}`,
});

export default connect(mapStateToProps)(Map);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/Map/index.js